export const STRUCTURED_THINKING_GUIDE = {
  path: "/structured-thinking",
  url: "https://ahavibes.xyz/structured-thinking",
  headline:
    "Structured Thinking: A Practical Guide to Finding Mental Clarity",
  description:
    "Learn how structured thinking helps you organize thoughts, separate facts from assumptions, and make better decisions with the EIER framework.",
  sections: [
    {
      id: "why-structured-thinking-matters",
      position: 1,
      name: "Why Structured Thinking Matters",
      description:
        "How the way you think — not how much — determines clarity, stress, and decision quality.",
    },
    {
      id: "what-is-structured-thinking",
      position: 2,
      name: "What Is Structured Thinking?",
      description:
        "A deliberate process for understanding events, separating facts from interpretations, and choosing thoughtful responses.",
    },
    {
      id: "why-structure-beats-motivation",
      position: 3,
      name: "Why Structure Beats Motivation",
      description:
        "Why frameworks outperform temporary motivation when you are tired, stressed, or overwhelmed.",
    },
    {
      id: "event-vs-interpretation",
      position: 4,
      name: "Event vs. Interpretation",
      description:
        "How confusing what happened with the story you tell about it creates unnecessary stress.",
    },
    {
      id: "evidence-based-thinking",
      position: 5,
      name: "Evidence-Based Thinking",
      description:
        "Testing assumptions with facts instead of accepting every thought automatically.",
    },
    {
      id: "respond-vs-react",
      position: 6,
      name: "Respond vs. React",
      description:
        "Creating space between an event and your action for better outcomes.",
    },
    {
      id: "thinking-frameworks",
      position: 7,
      name: "Thinking Frameworks",
      description:
        "Questions that interrupt automatic stories and strengthen decision-making.",
    },
    {
      id: "reflection-vs-rumination",
      position: 8,
      name: "Reflection vs. Rumination",
      description:
        "How intentional learning differs from repetitive thinking that keeps you stuck.",
    },
    {
      id: "the-eier-framework",
      position: 9,
      name: "The EIER Framework",
      description:
        "Event, Interpretation, Evidence, Response — a simple practice for thoughtful decisions.",
    },
    {
      id: "final-thoughts",
      position: 10,
      name: "Final Thoughts",
      description:
        "Choosing intentional thinking over automatic reactions for clearer, evidence-based decisions.",
    },
  ],
};
